var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _rect, _path17, _rect2, _rect3, _path18, _rect4, _rect5, _path19, _rect6, _rect7, _path20, _rect8, _path21, _path22, _path23, _path24;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPlatforms(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 75,
    viewBox: "0 0 85 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M78.424 36.861s-2.271 17.9-15.095 28.709c-10.398 7.628-24.64 12.125-42.63 3.797C5.398 58.658-8.513 44.562 8.363 14.224c0 0 14.155-16.362 39.586-12.79 21.006 6.12 32.747 17.528 30.475 35.427z",
    fill: "#E7EBF3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59 24H25a3 3 0 00-3 3v36a3 3 0 003 3h34a3 3 0 003-3V27a3 3 0 00-3-3z",
    fill: "#B9C0D3",
    fillOpacity: 0.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.027 27.467a.144.144 0 11-.124-.26.144.144 0 01.124.26z",
    fill: "#DFE2ED"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.671 19.303c3.132 0 5.671-2.53 5.671-5.652 0-3.12-2.539-5.651-5.67-5.651C19.538 8 17 10.53 17 13.651c0 3.122 2.539 5.652 5.671 5.652z",
    fill: "#CACEDB",
    stroke: "#848FB2",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.268 17.175c1.067 1.264 2.602 2.128 4.403 2.128 1.801 0 3.403-.798 4.404-2.128-.267-1.861-1.668-3.324-3.47-3.657.6-.332 1-.93 1-1.662a1.933 1.933 0 00-1.934-1.928 1.933 1.933 0 00-1.935 1.928c0 .732.4 1.33 1.001 1.662-1.801.333-3.202 1.796-3.47 3.657z",
    fill: "#fff",
    stroke: "#848FB2",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.162 28.303a3.157 3.157 0 003.163-3.152A3.157 3.157 0 0017.162 22 3.157 3.157 0 0014 25.151a3.157 3.157 0 003.162 3.152z",
    fill: "#CACEDB",
    stroke: "#848FB2",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.707 27.116c.595.705 1.45 1.187 2.455 1.187 1.005 0 1.898-.445 2.456-1.187a2.407 2.407 0 00-1.935-2.039c.335-.185.558-.519.558-.927 0-.593-.483-1.075-1.079-1.075-.595 0-1.079.482-1.079 1.075 0 .408.224.742.558.927a2.407 2.407 0 00-1.934 2.04z",
    fill: "#fff",
    stroke: "#848FB2",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.15 38.303A2.15 2.15 0 1011.149 34a2.15 2.15 0 00.001 4.302z",
    fill: "#CACEDB",
    stroke: "#848FB2",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.48 37.493c.405.48.987.81 1.67.81.683 0 1.29-.304 1.67-.81a1.64 1.64 0 00-1.316-1.392.715.715 0 00.38-.633.734.734 0 00-1.468 0c0 .278.152.506.38.633a1.64 1.64 0 00-1.316 1.392z",
    fill: "#fff",
    stroke: "#848FB2",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M40.15 13.303A2.15 2.15 0 1040.149 9a2.15 2.15 0 00.001 4.302z",
    fill: "#CACEDB",
    stroke: "#848FB2",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M38.48 12.493c.405.48.987.81 1.67.81.683 0 1.29-.304 1.67-.81a1.64 1.64 0 00-1.316-1.392.715.715 0 00.38-.633.734.734 0 00-1.468 0c0 .278.152.506.38.633a1.64 1.64 0 00-1.316 1.392z",
    fill: "#fff",
    stroke: "#848FB2",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M29 33.303c2.761 0 5-2.083 5-4.652S31.761 24 29 24s-5 2.082-5 4.651c0 2.57 2.239 4.652 5 4.652z",
    fill: "#CACEDB",
    stroke: "#848FB2",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M25.117 31.552c.942 1.04 2.294 1.75 3.883 1.75 1.588 0 3-.656 3.882-1.75-.235-1.533-1.47-2.736-3.059-3.01.53-.274.883-.766.883-1.368 0-.876-.765-1.587-1.706-1.587s-1.706.711-1.706 1.587c0 .602.353 1.094.882 1.368-1.588.273-2.823 1.477-3.059 3.01z",
    fill: "#fff",
    stroke: "#848FB2",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M12.85 50.303c1.574 0 2.85-1.187 2.85-2.652 0-1.464-1.276-2.651-2.85-2.651S10 46.187 10 47.651c0 1.465 1.276 2.652 2.85 2.652z",
    fill: "#CACEDB",
    stroke: "#848FB2",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M10.637 49.305a2.967 2.967 0 002.213.998c.905 0 1.71-.375 2.213-.998-.134-.874-.838-1.56-1.744-1.716.302-.156.503-.437.503-.78 0-.499-.435-.904-.972-.904-.537 0-.972.405-.972.904 0 .343.2.624.503.78-.906.156-1.61.842-1.744 1.716z",
    fill: "#fff",
    stroke: "#848FB2",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M64 18H35a3 3 0 00-3 3v36a3 3 0 003 3h29a3 3 0 003-3V21a3 3 0 00-3-3z",
    fill: "#fff",
    stroke: "#B9C0D3",
    strokeMiterlimit: 10
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 45.5,
    y: 23.5,
    width: 17,
    height: 4,
    rx: 0.5,
    fill: "#DFE2ED",
    stroke: "#DFE2ED"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#6D7AA4",
    d: "M46 24h12v1H46zM46 26h9v1h-9z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 23,
    width: 5,
    height: 5,
    rx: 2.5,
    fill: "#6D7AA4"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 45.5,
    y: 32.5,
    width: 17,
    height: 4,
    rx: 0.5,
    fill: "#DFE2ED",
    stroke: "#DFE2ED"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#6D7AA4",
    d: "M46 33h12v1H46zM46 35h9v1h-9z"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 32,
    width: 5,
    height: 5,
    rx: 2.5,
    fill: "#6D7AA4"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 45.5,
    y: 41.5,
    width: 17,
    height: 4,
    rx: 0.5,
    fill: "#DFE2ED",
    stroke: "#DFE2ED"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#6D7AA4",
    d: "M46 42h12v1H46zM46 44h9v1h-9z"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 41,
    width: 5,
    height: 5,
    rx: 2.5,
    fill: "#6D7AA4"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 45.5,
    y: 51.5,
    width: 17,
    height: 4,
    rx: 0.5,
    fill: "#DFE2ED",
    stroke: "#DFE2ED"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#6D7AA4",
    d: "M46 52h12v1H46zM46 54h9v1h-9z"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 51,
    width: 5,
    height: 5,
    rx: 2.5,
    fill: "#6D7AA4"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M27.612 63.303c3.652 0 6.613-2.754 6.613-6.152 0-3.397-2.96-6.151-6.613-6.151C23.961 51 21 53.754 21 57.151c0 3.398 2.96 6.152 6.612 6.152z",
    fill: "#CACEDB",
    stroke: "#848FB2",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M22.478 60.987c1.244 1.375 3.034 2.316 5.134 2.316 2.1 0 3.968-.869 5.134-2.316-.31-2.026-1.944-3.619-4.045-3.98.7-.362 1.167-1.014 1.167-1.81 0-1.158-1.011-2.098-2.256-2.098-1.245 0-2.256.94-2.256 2.098 0 .796.467 1.448 1.167 1.81-2.1.361-3.734 1.954-4.045 3.98z",
    fill: "#fff",
    stroke: "#848FB2",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M22.925 45.303c2.168 0 3.925-1.635 3.925-3.652 0-2.016-1.757-3.651-3.925-3.651S19 39.635 19 41.651c0 2.017 1.757 3.652 3.925 3.652z",
    fill: "#CACEDB",
    stroke: "#848FB2",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M19.877 43.928c.739.816 1.801 1.375 3.048 1.375s2.355-.516 3.048-1.375c-.185-1.203-1.155-2.148-2.402-2.363.416-.214.693-.601.693-1.073 0-.688-.6-1.246-1.34-1.246-.738 0-1.338.558-1.338 1.245 0 .473.277.86.692 1.074-1.246.215-2.216 1.16-2.4 2.363z",
    fill: "#fff",
    stroke: "#848FB2",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })));
}

export default __webpack_public_path__ + "./fonts/platforms.a6986fdf2d33c348c5a74d15d35230c8.svg";
export { SvgPlatforms as ReactComponent };